import type { Currency } from '@ps/web-core-enums';
import { integrationTesting } from '@ps/web-core-utils';
import React, { useEffect, useState } from 'react';
import { interval as createInterval } from 'rxjs';
import { share } from 'rxjs/operators';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import type { Jackpot } from '@swf/core/types/CasinoGame';

export interface Props {
  className?: string;
  currency: Currency;
  jackpot: Jackpot;
  visible: boolean;
}

export const REFRESH_RATE = 60;
export const UPDATE_RATE = 1000;
const interval = createInterval(UPDATE_RATE).pipe(share());

const JackpotAmount: React.FC<Props> = ({ currency, jackpot, visible }) => {
  const [value, setValue] = useState(jackpot.value);

  useEffect(() => {
    if (integrationTesting || (!visible && value !== jackpot.value) || jackpot.value < value) {
      setValue(jackpot.value);
    }
  }, [visible, jackpot.value, value]);

  const shouldSubscribe = jackpot.value > value;
  useEffect(() => {
    if (shouldSubscribe && visible) {
      const subscription = interval.subscribe(() => {
        setValue((value) => {
          const increment = (jackpot.value - value) / REFRESH_RATE;
          return Math.min(value + increment, jackpot.value);
        });
      });
      return () => subscription.unsubscribe();
    }
    return undefined;
  }, [jackpot.value, visible, shouldSubscribe]);

  return <CurrencyAmount {...jackpot} key={jackpot.key} value={value} currency={currency} />;
};

export default JackpotAmount;
